{
  "el": {
    "proposal": {
      "actions": {
        "addDescription": "Προσθήκη περιγραφής",
        "addDocuments": "Προσθήκη εγγράφων",
        "addSubchoiceList": "Προσθήκη λίστας υποεπιλογών",
        "addSubchoices": "Προσθήκη υποεπιλογής",
        "approve": "Έγκριση",
        "cancel": "Ακύρωση",
        "choice": {
          "collapse": "Σύμπτυξη επιλογών",
          "delete": "Διαγραφή επιλογής",
          "edit": "Επεξεργασία επιλογής",
          "expand": "Ανάπτυξη επιλογών"
        },
        "choice_list": {
          "delete": "Διαγραφή λίστας επιλογών"
        },
        "createNew": "Νέα πρόταση",
        "deleteDescription": "Διαγραφή περιγραφής",
        "deleteDocuments": "Διαγραφή εγγράφων",
        "delete_documents": "Διαγραφή εγγράφου | Διαγραφή εγγράφων",
        "delete_proposal": "Διαγραφή πρότασης",
        "delete_proposal_templates": "Διαγραφή προτύπου πρότασης",
        "dontShare": "Δεν χρειάζεται κοινοποίηση ακόμη",
        "duplicate": "Αντιγραφή",
        "edit": "Επεξεργασία",
        "generatePDF": "Δημιουργία PDF",
        "new": "Πρόταση",
        "newProposalCustomer": "Νέα πρόταση",
        "publish": "Δημοσίευση",
        "reject": "Αναίρεση έγκρισης",
        "save": "Αποθήκευση",
        "share": "Κοινοποίηση",
        "shareWithProjectPartners": "Κοινοποίηση εγγράφων στους συνεργάτες έργου...",
        "share_units": "Κοινοποίηση σε ακίνητα",
        "signAndApprove": "Υπογραφή και έγκριση πρότασης",
        "signElectronically": "Ή ηλεκτρονική υπογραφή",
        "steps": {
          "collapse": "Σύμπτυξη βημάτων",
          "expand": "Ανάπτυξη βημάτων"
        },
        "stop_template_sync": "Διακοπή συγχρονισμού με το πρότυπο",
        "submit": "Υποβολή",
        "uploadAndApprove": "Ανέβασμα και έγκριση πρότασης",
        "uploadSignableDocument": "Ανέβασμα υπογεγραμμένου εγγράφου για έγκριση"
      },
      "attributes": {
        "amount_gross": "Μεικτή προσφορά",
        "amount_net": "Καθαρή προσφορά",
        "choice_lists": {
          "description": "Περιγραφή",
          "name": "Όνομα"
        },
        "choices": {
          "description": "Περιγραφή",
          "images": "Εικόνες",
          "name": "Όνομα",
          "price_gross": "Μεικτή τιμή είδους",
          "price_net": "Καθαρή τιμή είδους",
          "quantity": "Ποσότητα",
          "quantity_fixed": "Σταθερή ποσότητα",
          "quantity_max": "Μέγιστη",
          "quantity_min": "Ελάχιστη",
          "quantity_not_fixed": "Ο πελάτης συμπληρώνει την ποσότητα",
          "selected_default": "Πάντα επιλεγμένη",
          "total_price_gross": "Σύνολο μεικτό",
          "total_price_net": "Σύνολο καθαρό"
        },
        "description": "Πώς θα περιέγραφες αυτή την πρόταση;",
        "documents": "Προσθήκη εγγράφων",
        "name": "Όνομα",
        "subtitle": "Έτσι οι άλλοι θα την αναφέρουν πιο εύκολα",
        "title": "Δώσε έναν τίτλο στην πρότασή σου",
        "type": {
          "choices": "Λίστα επιλογών",
          "fixed": "Σταθερή προσφορά"
        },
        "vat_percentage": "ΦΠΑ %"
      },
      "labels": {
        "accepted": "Εγκεκριμένη",
        "addExtraBudget": "Προσθήκη επιπλέον προϋπολογισμού",
        "allUnitsShared": "Αυτό το πρότυπο έχει ήδη κοινοποιηθεί σε όλα τα ακίνητα",
        "already_approved": "Αυτή η πρόταση έχει ήδη εγκριθεί.",
        "amount_net_total": "Συνολική καθαρή προσφορά",
        "amount_total": "Συνολική μεικτή προσφορά",
        "approval_feedback": {
          "label": "Σχόλιο (προαιρετικό)",
          "placeholder": "Μοιράσου με την ομάδα τυχόν ερωτήσεις, όρους ή επιπλέον πληροφορίες."
        },
        "approve": "Έγκριση {name}",
        "approved": "Εγκεκριμένη",
        "approvedDate": "Εγκρίθηκε {date}",
        "ask_client_to_undo": "Δεν μπορείς να επεξεργαστείς εγκεκριμένη πρόταση. Επικοινώνησε πρώτα με {client} για να γίνει αναίρεση της έγκρισης.",
        "batchProposalsTemplate": "<p>Αυτή η πρόταση θα δημιουργηθεί για {units_count} ακίνητα.</p></br><p>Επειδή θα δημιουργηθεί για πολλά ακίνητα, τη μετατρέψαμε σε πρότυπο. Θα βρεις αυτό το πρότυπο στην καρτέλα «Πρότυπα προτάσεων».</p></br><p>Τα πρότυπα διευκολύνουν την επεξεργασία ή τη διαγραφή όλων των προτάσεων που είναι κοινοποιημένες με αυτό το πρότυπο.</p>",
        "batchProposalsWarning": "Αυτή η πρόταση θα δημιουργηθεί για {units_count} ακίνητα. Αν χρειαστεί να κάνεις αλλαγές αργότερα, θα πρέπει να επεξεργαστείς την καθεμία ξεχωριστά.",
        "budget": "Προϋπολογισμός",
        "builder": {
          "can_select_multiple": "Δυνατότητα πολλαπλής επιλογής",
          "item": "Προσθήκη επιλογής",
          "multiple_choices_possible": "Επιτρέπονται πολλαπλές επιλογές",
          "must_choose_item": "Υποχρεωτική επιλογή",
          "options": "Επιλογές",
          "section": "Λίστα επιλογών",
          "step": "Βήμα",
          "step_basic": "Βασικές πληροφορίες",
          "step_details": "Λεπτομέρειες",
          "step_documents": "Έγγραφα",
          "step_internal": "Εσωτερικές πληροφορίες",
          "step_visibility": "Κοινοποίηση σε"
        },
        "by": "από",
        "choice_lists": {
          "add_another": "Προσθήκη ακόμη μιας λίστας επιλογών",
          "create": "Δημιούργησε λίστες επιλογών για την πρόταση",
          "empty_help": "Ξεκίνα προσθέτοντας την πρώτη σου λίστα επιλογών. Οι λίστες επιλογών ομαδοποιούν τις επιλογές για ένα συγκεκριμένο είδος, π.χ. «πλακάκια δαπέδου». Αφού προσθέσεις λίστες επιλογών, μπορείς να προσθέσεις μία ή περισσότερες επιλογές.",
          "selected": "Επιλεγμένο"
        },
        "choices": {
          "add_another": "Προσθήκη ακόμη μιας επιλογής",
          "create": "Πρόσθεσε επιλογές σε {choiceListName}",
          "optional": "προαιρετικό",
          "selected_default": "Αυτή η επιλογή θα είναι πάντα επιλεγμένη και η τιμή της θα υπολογίζεται αυτόματα στη συνολική τιμή. Ο πελάτης δεν θα μπορεί να την αποεπιλέξει.",
          "selected_default_tooltip": "Αυτή η επιλογή περιλαμβάνεται πάντα και η τιμή της υπολογίζεται αυτόματα στο σύνολο.",
          "subtotal": "Μερικό σύνολο"
        },
        "clickToChangeVisibility": "Κάνε κλικ για να αλλάξεις την ορατότητα",
        "closed": "Αυτή η απόφαση είναι πλέον κλειστή. Δεν μπορείς πια να εγκρίνεις πρόταση.",
        "createProposal": "Δημιουργία πρότασης",
        "createProposals": "Δημιουργία πρότασης",
        "created": "Δημιουργήθηκε",
        "createdBy": "Δημιουργήθηκε από {uploader}",
        "customer": "Πελάτης",
        "customerHasNotSelectedYet": "Ο πελάτης δεν έχει κάνει ακόμη επιλογή",
        "customer_name_confirm": "Γράψε <i><b>{customerName}</b></i> για να εγκρίνεις αυτή την πρόταση.",
        "customer_name_proceed": "Γράψε <i><b>{customerName}</b></i> για να συνεχίσεις.",
        "customer_offer": "Προσφορά προς τον πελάτη",
        "customers": "Πελάτες",
        "decision_not_interested": "Η απόφαση έχει σημειωθεί ως «Χωρίς ενδιαφέρον».",
        "definedPerUnit": "Ορίζεται ανά ακίνητο",
        "delete_proposal_template": "<p>Αν διαγράψεις αυτό το πρότυπο, θα διαγραφούν και όλες οι συγχρονισμένες προτάσεις.<br>Αν δεν το θέλεις αυτό, χρησιμοποίησε τον διακόπτη παρακάτω.</p>",
        "depends_on_customer_input": "Εξαρτάται από τα στοιχεία που θα δώσει ο πελάτης",
        "documentsRequireSignature": "Ο πελάτης πρέπει να υπογράψει έγγραφα",
        "documents_shared_partners": "Στους συνεργάτες έργου κοινοποιούνται μόνο τα έγγραφα της πρότασης.",
        "duplicating": "Αντιγραφή...",
        "edit": "Επεξεργασία",
        "editNotAllowed": "Δεν επιτρέπεται η επεξεργασία ή η διαγραφή εγκεκριμένης πρότασης. Κάνε πρώτα αναίρεση της έγκρισης.",
        "editProposal": "Επεξεργασία πρότασης",
        "excl%VAT": "χωρίς ΦΠΑ {vat}%",
        "exclVAT": "χωρίς ΦΠΑ",
        "export_documents": "Εξαγωγή εγγράφων",
        "extraBudget": "Επιπλέον προϋπολογισμός",
        "fractions_sent_count_header": "Δεν είναι δυνατή η δημιουργία πρότασης",
        "fractions_sent_count_message": "Έχουν ήδη σταλεί δόσεις που βασίζονται σε αυτή την απόφαση. Άλλαξε πρώτα αυτές τις δόσεις σε πρόχειρες για να συνεχίσεις.",
        "full_prices": "Χρήση πλήρων τιμών. Η Ziggu θα δημιουργεί αυτόματα αναβαθμίσεις με βάση τον προϋπολογισμό της απόφασης",
        "generatingPDF": "Δημιουργία PDF...",
        "has_requested_changes": "Αυτή η πρόταση έχει ήδη εκκρεμές αίτημα αλλαγών.",
        "hideDetails": "Απόκρυψη λεπτομερειών",
        "installments_connected": "Υπάρχουν δόσεις συνδεδεμένες με αυτή την πρόταση.",
        "internalNote": "Εσωτερική σημείωση",
        "internalNoteSubtitle": "Αυτή η σημείωση είναι ορατή μόνο σε σένα και στην ομάδα σου.",
        "internal_info": "Εσωτερικές πληροφορίες",
        "keepHidden": "Να παραμείνει κρυφή",
        "keep_synced_proposals": "Διατήρησε τις συγχρονισμένες προτάσεις ώστε να γίνουν αυτόνομες προτάσεις.",
        "link_to_template": "Σύνδεση με το πρότυπο;",
        "link_to_template_after_create": "Σύνδεσε αμέσως αυτή την πρόταση με το νέο πρότυπο μετά τη δημιουργία.",
        "makeDecision": "Ενέκρινε μια πρόταση για {decision_name} πατώντας το κουμπί έγκρισης",
        "margin": "Περιθώριο",
        "marginBudget%": "Περιθώριο προϋπολογισμού ({margin}%)",
        "marginSurcharge%": "Περιθώριο αναβαθμίσεων ({margin}%)",
        "marginSurchargesExtraBudget%": "Περιθώριο επιπλέον προϋπολογισμού + αναβαθμίσεων ({margin}%)",
        "new": "Νέα πρόταση",
        "noImage": "Χωρίς εικόνα",
        "no_budget_available_yet": "Δεν ισχύει",
        "no_documents": "Η πρόταση δεν περιέχει έγγραφα.",
        "no_edit_details": "Από αυτή την πρόταση εξαρτώνται άλλα στοιχεία. Επικοινώνησε με τον πελάτη αν θέλεις να επεξεργαστείς λεπτομέρειες",
        "no_edit_details_installments": "Αυτή η πρόταση έχει τουλάχιστον μία τιμολογημένη ή πληρωμένη δόση. Για να επεξεργαστείς τις λεπτομέρειες της πρότασης, πρέπει πρώτα να αλλάξεις την κατάσταση αυτής της δόσης σε «Αναμενόμενη». Πήγαινε στα {link}.",
        "no_edit_details_installments_link": "οικονομικά",
        "no_edit_documents": "Όταν μια πρόταση εγκριθεί, τα έγγραφα δεν μπορούν να τροποποιηθούν.",
        "notApplicable": "Δεν ισχύει",
        "notDefined": "Δεν έχει οριστεί",
        "notSeenYetByCustomer": "Δεν το έχει δει ακόμη ο πελάτης",
        "notSelectedYet": "Κάνε τις επιλογές σου για να δεις το σύνολο",
        "notSharedYet": "Δεν έχει κοινοποιηθεί ακόμη",
        "not_approved_yet": "Αυτή η πρόταση δεν έχει εγκριθεί ακόμη.",
        "not_interested_reset_header": "Η απόφαση σημειώθηκε ως «Χωρίς ενδιαφέρον»",
        "not_interested_reset_message": "Αυτή η απόφαση είναι αυτή τη στιγμή σημειωμένη ως «Χωρίς ενδιαφέρον». Αν δημιουργήσεις πρόταση, η κατάσταση «Χωρίς ενδιαφέρον» θα επανέλθει.",
        "only_visible_team_partners": "Ορατό μόνο στην ομάδα",
        "other": "Άλλο",
        "proposalFor": "Πρόταση για",
        "proposal_template_sync_note": "Οι αλλαγές σε ένα πρότυπο πρότασης ενημερώνουν όλες τις συγχρονισμένες (μη εγκεκριμένες) προτάσεις.",
        "proposal_unapprove_not_possible": "Δεν είναι δυνατή η αναίρεση της έγκρισης",
        "proposalsApproved": "Εγκεκριμένες προτάσεις",
        "proposalsOther": "Άλλες προτάσεις",
        "relaunch": "Επανεκκίνηση πρότασης",
        "request_changes": {
          "body": "Δώσε μας λίγα παραπάνω σχόλια για το τι πρέπει να αλλάξει σε αυτή την πρόταση",
          "feedback": "Σχόλια",
          "title": "Αίτημα αλλαγών"
        },
        "requested_changes": "Ζητήθηκαν αλλαγές",
        "requiresSignature": "Πρέπει να υπογράψει έγγραφα",
        "seenByCustomer": "Το είδε ο πελάτης:",
        "selectUnitsShare": "Επίλεξε τα ακίνητα για την κοινοποίηση του προτύπου",
        "shareCustomerDescription": "Αυτή η πρόταση συνδέεται με μια απόφαση που δεν έχει κοινοποιηθεί ακόμη στον πελάτη. Θέλεις να γίνει κοινοποίηση και της απόφασης, ώστε ο πελάτης να δει αμέσως αυτή την πρόταση;",
        "shareCustomerTitle": "Κοινοποίηση της απόφασης στον πελάτη;",
        "shareDecision": "Κοινοποίηση απόφασης",
        "shareExtraAlert": "Η απόφαση θα κοινοποιηθεί κι αυτή μόλις πατήσεις αποστολή",
        "sharePartnerTitle": "Κοινοποίηση της απόφασης στον συνεργάτη;",
        "sharePartnersDescription": "Αυτή η πρόταση συνδέεται με μια απόφαση που δεν έχει κοινοποιηθεί ακόμη στον συνεργάτη. Θέλεις να γίνει κοινοποίηση και της απόφασης, ώστε ο συνεργάτης να δει αμέσως αυτή την πρόταση;",
        "sharedWith": "Κοινοποιήθηκε σε",
        "showAndEditDetails": "Εμφάνιση και επεξεργασία λεπτομερειών",
        "single_approval_warning": {
          "message": "Επικοινώνησε με τη Ziggu για να ενεργοποιηθεί η έγκριση πολλών προτάσεων.",
          "title": "Μπορείς να συνεχίσεις να δημιουργείς προτάσεις, αλλά ο πελάτης μπορεί να εγκρίνει μόνο μία."
        },
        "skip_customer": "Το έργο παρακάμπτει το βήμα του πελάτη.",
        "surcharges": "Αναβαθμίσεις",
        "surcharges_extra": "Επιπλέον αναβαθμίσεις",
        "synced_with_template": "Συγχρονισμένη με πρότυπο πρότασης",
        "synced_with_units": "Συγχρονισμένη με 1 ακίνητο | Συγχρονισμένη με {unit_count} ακίνητα",
        "template_accept_confirm": "<p>Αυτή η πρόταση είναι συγχρονισμένη με πρότυπο πρότασης. Όταν την εγκρίνεις, ο συγχρονισμός θα σταματήσει και η πρόταση δεν θα ενημερώνεται πια όταν αλλάζει το πρότυπο.</p></br><p>Θέλεις σίγουρα να εγκρίνεις αυτή την πρόταση;</p>",
        "template_edit_confirm": "<p>Αυτή η πρόταση είναι συγχρονισμένη με πρότυπο πρότασης. Όταν την επεξεργαστείς, ο συγχρονισμός θα σταματήσει και η πρόταση δεν θα ενημερώνεται πια όταν αλλάζει το πρότυπο.</p></br><p>Θέλεις σίγουρα να συνεχίσεις την επεξεργασία αυτής της πρότασης;</p>",
        "totalBudget": "Συνολικός προϋπολογισμός",
        "totalNetOffer": "Καθαρή προσφορά",
        "total_excl_vat": "Σύνολο χωρίς ΦΠΑ",
        "total_incl_vat": "Σύνολο με ΦΠΑ",
        "total_vat": "Σύνολο ΦΠΑ",
        "typeToShare": "Τύπος πρότασης προς κοινοποίηση",
        "unit_not_activated": "Το ακίνητο δεν είναι ενεργοποιημένο.",
        "uploadDocuments": "Ανέβασμα υπογεγραμμένων εγγράφων",
        "uploadSignedDocument": "Ή ανέβασε υπογεγραμμένο έγγραφο",
        "vat_excl": "χωρίς ΦΠΑ",
        "vat_excl_with_number": "χωρίς ΦΠΑ {vat}%",
        "visibleForCustomer": "Ορατό στον πελάτη",
        "writeEmployeeNameAccept": "Γράψε <i><b>{employeeName}</b></i> για να εγκρίνεις αυτή την πρόταση.",
        "writeEmployeeNameDelete": "Γράψε <i><b>{employeeName}</b></i> για να διαγράψεις αυτή την πρόταση.",
        "writeEmployeeNameReject": "Γράψε <i><b>{employeeName}</b></i> για να αναιρέσεις την έγκριση αυτής της πρότασης."
      },
      "placeholders": {
        "customers": {
          "none": {
            "subtitle": "Σύντομα θα βρεις εδώ μια πρόταση προς έγκριση",
            "title": "Δεν υπάρχουν ακόμη προτάσεις για την απόφαση {decision_name}"
          }
        },
        "employees": {
          "new": {
            "subtitle": "Πρότεινε μία ή περισσότερες προσφορές και άσε τον πελάτη σου να αποφασίσει.",
            "title": "Δημιούργησε μια πρόταση"
          },
          "proposalNotice": "Σημαντικό: μπορεί να εγκριθεί μόνο 1 πρόταση. Μπορείς πάντα να επεξεργαστείς μια υπάρχουσα πρόταση και να προσθέσεις νέα έγγραφα.",
          "template": {
            "subtitle": "Όταν δημιουργείς προτάσεις μαζικά, θα εμφανίζονται εδώ",
            "title": "Δεν έχουν δημιουργηθεί ακόμη πρότυπα προτάσεων."
          }
        },
        "partners": {
          "new": {
            "subtitle": "Πρότεινε μία ή περισσότερες προσφορές και άσε τον πελάτη να αποφασίσει.",
            "title": "Δημιούργησε μια πρόταση"
          },
          "proposalNotice": "Σημαντικό: μπορεί να εγκριθεί μόνο 1 πρόταση. Μπορείς πάντα να επεξεργαστείς μια υπάρχουσα πρόταση και να προσθέσεις νέα έγγραφα. Αν μια πρόταση έχει ήδη εγκριθεί, ένα μέλος της ομάδας μπορεί να κάνει αναίρεση πριν προστεθούν επιπλέον έγγραφα."
        }
      },
      "toasts": {
        "convert": "Η πρόταση μετατράπηκε σε πρότυπο με επιτυχία",
        "create": "Η πρόταση δημιουργήθηκε με επιτυχία",
        "delete": "Η πρόταση διαγράφηκε με επιτυχία",
        "shareSuccess": "Οι προτάσεις κοινοποιήθηκαν με επιτυχία",
        "update": "Η πρόταση ενημερώθηκε με επιτυχία"
      },
      "validation": {
        "amountNotUpdatable": "Το ποσό δεν μπορεί να ενημερωθεί: κάποιες δόσεις εξαρτώνται από αυτό",
        "choice_list": {
          "needChoice": "Αυτή η λίστα επιλογών χρειάζεται τουλάχιστον 1 επιλογή",
          "needSelection": "Αυτή η επιλογή απαιτεί ένα επιλεγμένο είδος"
        },
        "choices": {
          "lessThanOrEqual": "Ο αριθμός πρέπει να είναι μικρότερος ή ίσος με {max_number}",
          "needPriceItem": "Η τιμή ανά είδος είναι υποχρεωτική",
          "needSelection": "Απαιτείται επιλογή",
          "needVatPercentage": "Το ποσοστό ΦΠΑ είναι υποχρεωτικό",
          "quantityBetween": "Η ποσότητα πρέπει να είναι μεταξύ {quantity_min} και {quantity_max}",
          "quantityNotZero": "Η ποσότητα πρέπει να είναι τουλάχιστον 1",
          "quantityRequired": "Η ποσότητα είναι υποχρεωτική",
          "uniqueNames": "Τα ονόματα πρέπει να είναι μοναδικά"
        },
        "nameNotCorrect": "Το όνομα είναι υποχρεωτικό και πρέπει να ταιριάζει",
        "needName": "Ο τίτλος είναι υποχρεωτικός",
        "needNumber": "Πρέπει να είναι αριθμός (π.χ. 85)",
        "need_request_changes_note": "Δώσε σχόλια σχετικά με το αίτημα αλλαγών σου",
        "readAllDocuments": "Πρέπει να έχεις διαβάσει όλα τα έγγραφα",
        "requiresSignature": "Σημείωσε τουλάχιστον 1 έγγραφο που πρέπει να υπογράψει ηλεκτρονικά ο πελάτης. Απενεργοποίησε τον διακόπτη παρακάτω αν δεν χρειάζεσαι υπογραφές.",
        "share": {
          "needSelection": "Επίλεξε σε ποιον θα γίνει η κοινοποίηση της πρότασης | Επίλεξε σε ποιον θα γίνει η κοινοποίηση των προτάσεων",
          "needType": "Επίλεξε τον τύπο των προτάσεων"
        },
        "uploadAtLeast1Document": "Ανέβασε τουλάχιστον 1 υπογεγραμμένο έγγραφο"
      }
    }
  }
}
